import React from "react"
import styled from "styled-components"

import common from "./common"

const Card = ({ children, ...props }) => <Style {...props}>{children}</Style>

export default Card

const Style = styled.article.attrs((props) => ({
  className: "card",
}))`
  ${common};
`
